export class Sort {

    private sortOrder = 1;

    constructor() {

    }

    public startSort(property, order, type = "") {
        if (order === "desc") {
            this.sortOrder = -1;
        }
        return (a, b) => {
            if (type === "date") {
                return this.sortData(new Date(a[property]), new Date(b[property]));
            } else {
                return this.sortData(a[property], b[property]);
            }
        }
    }

    private sortData(a, b) {
        if (a > b) return -1 * this.sortOrder;
        if (a < b) return 1 * this.sortOrder; 
        
        return 0 * this.sortOrder;
    }
}